export default __webpack_public_path__ + "d2d11832026063ae83ad44d799dc9bac.png";